import { Component } from '@angular/core';

export enum HowItWorksViewType {
  FREELANCER = 'freelancer',
  CLIENT = 'client',
}

@Component({
  template: `
    <app-how-it-works-page-meta-wrapper
      title="Freelancer - How It Works"
      i18n-title="How It Works page meta title"
      description="It's so simple to use Freelancer!"
      i18n-description="How It Works page description"
    ></app-how-it-works-page-meta-wrapper>
    <app-how-it-works-page-hero
      (changeViewEvent)="switchToView($event)"
    ></app-how-it-works-page-hero>
    <app-how-it-works-page-client-view
      *ngIf="currentView === HowItWorksViewType.CLIENT"
    ></app-how-it-works-page-client-view>
    <app-how-it-works-page-freelancer-view
      *ngIf="currentView === HowItWorksViewType.FREELANCER"
    ></app-how-it-works-page-freelancer-view>
  `,
  styleUrls: ['./how-it-works-page.component.scss'],
})
export class HowItWorksPageComponent {
  HowItWorksViewType = HowItWorksViewType;
  currentView = HowItWorksViewType.CLIENT;

  switchToView(view: HowItWorksViewType) {
    this.currentView = view;
  }
}
